let swiperInstance = undefined;

function initSwiper() {
  const screenWidth = window.innerWidth;

  // 768px以上（PC・タブレット）の場合のみSwiperを動かす
  if (screenWidth >= 768) {
    if (swiperInstance === undefined) {
      swiperInstance = new Swiper("#bullets", {
        loop: true,
        speed: 1000, 
        centeredSlides: true,        // 中央揃え
        autoplay: {
          delay: 3000, 
          disableOnInteraction: false 
        },
        preventClicksPropagation: false,    
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination", 
          type: "bullets",
          clickable: true            
        },
        slidesPerView: 'auto',        
        spaceBetween: 40,
        breakpoints: {
          1024: {     
            spaceBetween: 30
          }
        }
      });
    }
  } else {
    // 767px以下（スマホサイズ）になったらSwiperを完全に破壊して動作を止める
    if (swiperInstance !== undefined) {
      swiperInstance.destroy(true, true);
      swiperInstance = undefined;
    }
  }
}

// 画面の読み込み時と、画面サイズが変更された時に判定を走らせる
window.addEventListener('load', initSwiper);
window.addEventListener('resize', initSwiper);
